import React from 'react'
import TagBrandEditPage from './TagBrandEditPage'

const TagBrandEditContainer = (props) => {
    const idTagBrand = props.match.params.id || ''
    return (
        <div className='TagBrandEditContainer'>
            <TagBrandEditPage idTagBrand={idTagBrand} />
        </div>
    )
}

export default TagBrandEditContainer